module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "activity-settings"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [(_vm.isLoading) ? _c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [(!_vm.isLoading) ? _c('mu-table', {
    attrs: {
      "showCheckbox": false
    }
  }, [_c('mu-thead', [_c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingDevice'))
    }
  }), _vm._v(" "), _c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingOS'))
    }
  }), _vm._v(" "), _c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingIp'))
    }
  }), _vm._v(" "), _c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingDate'))
    }
  })], 1), _vm._v(" "), _c('mu-tbody', _vm._l((_vm.logins), function(login, index) {
    return _c('mu-tr', {
      key: ("login-" + index)
    }, [_c('mu-td', {
      domProps: {
        "textContent": _vm._s(login.device || '-')
      }
    }), _vm._v(" "), _c('mu-td', {
      domProps: {
        "textContent": _vm._s(login.os)
      }
    }), _vm._v(" "), _c('mu-td', [_vm._v(_vm._s(login.ip_address.replace(', 35.244.130.1', ' ')))]), _vm._v(" "), _c('mu-td', {
      domProps: {
        "textContent": _vm._s(_vm.formatDate(login.date_created))
      }
    })], 1)
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "suspicious"
  }, [_c('p', [_vm._v("Notice anything suspicious? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(".")], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a169b3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Activity.vue
// module id = 3822
// module chunks = 1